import script from "./ThirdSaiPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ThirdSaiPage.vue?vue&type=script&setup=true&lang=js"

import "./ThirdSaiPage.vue?vue&type=style&index=0&id=77587fc9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77587fc9"]])

export default __exports__